module.exports = __webpack_public_path__ + "img/ewm.4bf5fbbd.png";